// extracted by mini-css-extract-plugin
module.exports = {"container":"TabsHorizontal_container__2BMWk","tab":"TabsHorizontal_tab__1EsFg","disabled":"TabsHorizontal_disabled__G-_w-","selected":"TabsHorizontal_selected__2pn22"};